import React, { useEffect, useState } from "react";
import { useParams,useNavigate } from "react-router-dom";
import "../QuizHub/QuizHub.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import hh from "../../images/hub-img.webp";
import cc from "../../images/hub-card.webp";
import gg from "../../images/gift-green.svg";
import axios from "axios";
import ff from "../../images/pp-logo.gif";
import { END_URL, IMG_URL } from "../../config";
import { slugify } from '../../utils/slugify';
import arr from "../../images/downarr.svg"
import ang from "../../images/right-angle.svg";
import { saveCurrentPage } from "../../utils/breadcrumb";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

function HubTopicDetail({slug,token,onsignup,onLoginChange,userdetail}) {

    const navigate = useNavigate();

    const [hubTopic, sethubTopic] = useState(null);

    const [faqData,setfaqData]= useState([]);

    const [loading, setLoading] = useState(true);

    const [openIndex, setOpenIndex] = useState(0);

    const [CarrerModal, setCarrerModal] = useState(false);
    const [careerContent, setCareerContent] = useState("");

    const previousPage = JSON.parse(localStorage.getItem("previousPage") || "{}");
    const previousTitle = previousPage.title || "Home";
    const previousUrl = previousPage.url || "/";

    useEffect(() => {
        fetchHub();
    }, [slug]);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


    const fetchHub = async () => {
        try {
            setLoading(true);

            const response = await axios.get(
                `${END_URL}/hub-topic-details/${slug}`
            );

            sethubTopic(response.data?.hub_topic_detail);
            setfaqData(response.data?.hub_topic_detail?.faqs);
  
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {

        return (

                <div className="loadingDiv" >
                
                    <img src={ff}  alt="Loading..." />
        
                </div>
        );
    }

   
  return (
    <>
    <div className="hub-main hub-topic-detail">
      <div className="ques-main hub-cont-banner">
        <div className="container-fluid">
          <div className="row ques-row">
            <div className="col-12">
              <div className="ques-top" style={{'--banner_image': `url(${IMG_URL}/d0/${hubTopic?.topic_banner_image})`}}>

                <img src={`${IMG_URL}/d0/${hubTopic?.topic_banner_image}`} alt={hubTopic?.topic_banner_image_alt} style={{ display: 'none' }} />
          
                <div className="ques-top-title hub-top-change-title">
                
                  <div className="quiz-banner-content" dangerouslySetInnerHTML={{__html:hubTopic?.topic_banner_content}}/>

                      <div className="hub-banner-bnts">

                        {hubTopic?.topic_banner_btn_1 && hubTopic?.topic_banner_btn_link_1 && (

                              hubTopic.topic_banner_btn_link_1 === "login" ? (

                                <button
                                  type="button"
                                  className="new-commom-btn homearche-explore"
                                  style={{
                                    "--blur_button_color":hubTopic.topic_banner_btn_1_color,
                                    '--topic_banner_btn_1_color':hubTopic.topic_banner_btn_1_color ,
                                    '--topic_banner_btn_1_color_hover':hubTopic.topic_banner_btn_1_hover_color,
                                    '--luminus_button_color_15': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 15%, white)`,
                                    '--luminus_button_color_25': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 25%, white)`,
                                    '--luminus_button_color_38': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 38%, white)`,
                                    '--luminus_button_color_45': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 45%, white)`,
                                    '--luminus_button_color_50': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 50%, white)`,
                                    '--luminus_button_color_55': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 55%, white)`,
                                    '--luminus_button_color_70': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 70%, white)`,
                                    '--luminus_button_color_85': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 85%, white)`,
                                    '--luminus_button_color_92': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 92%, white)`,
                                    '--luminus_button_color_100': hubTopic.topic_banner_btn_1_color,
                                  }}

                                  onClick={() => onsignup(true)}
                                >
                                  <span>{hubTopic.topic_banner_btn_1}</span>

                                  <span className="righ-arr">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                  </span>
                                </button>

                              ) : hubTopic.topic_banner_btn_link_1 === "sign-up" ? (

                                <button
                                  type="button"
                                  className="new-commom-btn homearche-explore"
                                  onClick={() => onLoginChange(true)}
                                  style={{
                                    "--blur_button_color":hubTopic.topic_banner_btn_1_color,
                                    '--topic_banner_btn_1_color':hubTopic.topic_banner_btn_1_color ,
                                    '--topic_banner_btn_1_color_hover':hubTopic.topic_banner_btn_1_hover_color,
                                    '--luminus_button_color_15': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 15%, white)`,
                                    '--luminus_button_color_25': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 25%, white)`,
                                    '--luminus_button_color_38': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 38%, white)`,
                                    '--luminus_button_color_45': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 45%, white)`,
                                    '--luminus_button_color_50': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 50%, white)`,
                                    '--luminus_button_color_55': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 55%, white)`,
                                    '--luminus_button_color_70': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 70%, white)`,
                                    '--luminus_button_color_85': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 85%, white)`,
                                    '--luminus_button_color_92': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 92%, white)`,
                                    '--luminus_button_color_100': hubTopic.topic_banner_btn_1_color,
                                  }}
                                >
                                  <span>{hubTopic.topic_banner_btn_1}</span>

                                  <span className="righ-arr">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                  </span>
                                </button>

                              ) : (

                                <a
                                  href={`/${hubTopic.topic_banner_btn_link_1}`}
                                  className="new-commom-btn homearche-explore"
                                   style={{
                                    "--blur_button_color":hubTopic.topic_banner_btn_1_color,
                                    '--topic_banner_btn_1_color':hubTopic.topic_banner_btn_1_color ,
                                    '--topic_banner_btn_1_color_hover':hubTopic.topic_banner_btn_1_hover_color,
                                    '--luminus_button_color_15': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 15%, white)`,
                                    '--luminus_button_color_25': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 25%, white)`,
                                    '--luminus_button_color_38': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 38%, white)`,
                                    '--luminus_button_color_45': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 45%, white)`,
                                    '--luminus_button_color_50': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 50%, white)`,
                                    '--luminus_button_color_55': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 55%, white)`,
                                    '--luminus_button_color_70': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 70%, white)`,
                                    '--luminus_button_color_85': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 85%, white)`,
                                    '--luminus_button_color_92': `color-mix(in srgb, ${hubTopic.topic_banner_btn_1_color} 92%, white)`,
                                    '--luminus_button_color_100': hubTopic.topic_banner_btn_1_color,
                                  }}
                                >
                                  <span>{hubTopic.topic_banner_btn_1}</span>

                                  <span className="righ-arr">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                  </span>
                                </a>

                              )

                            )}

                          {hubTopic?.topic_banner_btn_link_2 && hubTopic?.topic_banner_btn_2 && (

                              hubTopic.topic_banner_btn_link_2 === "login" ? (

                                <button
                                  type="button"
                                  className="new-commom-btn hub-banner-reveal"
                                  style={{
                                    "--blur_button_color":hubTopic.topic_banner_btn_2_color,
                                    '--topic_banner_btn_2_color':hubTopic.topic_banner_btn_2_color ,
                                    '--topic_banner_btn_2_color_hover':hubTopic.topic_banner_btn_2_hover_color,
                                    '--luminus_button_color_15': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 15%, white)`,
                                    '--luminus_button_color_25': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 25%, white)`,
                                    '--luminus_button_color_38': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 38%, white)`,
                                    '--luminus_button_color_45': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 45%, white)`,
                                    '--luminus_button_color_50': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 50%, white)`,
                                    '--luminus_button_color_55': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 55%, white)`,
                                    '--luminus_button_color_70': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 70%, white)`,
                                    '--luminus_button_color_85': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 85%, white)`,
                                    '--luminus_button_color_92': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 92%, white)`,
                                    '--luminus_button_color_100': hubTopic.topic_banner_btn_2_color,
                                  }}
                                  onClick={() => onsignup(true)}
                                >
                                  <span>{hubTopic.topic_banner_btn_2}</span>

                                  <span className="righ-arr">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                  </span>
                                </button>

                              ) : hubTopic.topic_banner_btn_link_2 === "sign-up" ? (

                                <button
                                  type="button"
                                  className="new-commom-btn hub-banner-reveal"
                                  style={{
                                    "--blur_button_color":hubTopic.topic_banner_btn_2_color,
                                    '--topic_banner_btn_2_color':hubTopic.topic_banner_btn_2_color ,
                                    '--topic_banner_btn_2_color_hover':hubTopic.topic_banner_btn_2_hover_color,
                                    '--luminus_button_color_15': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 15%, white)`,
                                    '--luminus_button_color_25': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 25%, white)`,
                                    '--luminus_button_color_38': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 38%, white)`,
                                    '--luminus_button_color_45': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 45%, white)`,
                                    '--luminus_button_color_50': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 50%, white)`,
                                    '--luminus_button_color_55': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 55%, white)`,
                                    '--luminus_button_color_70': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 70%, white)`,
                                    '--luminus_button_color_85': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 85%, white)`,
                                    '--luminus_button_color_92': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 92%, white)`,
                                    '--luminus_button_color_100': hubTopic.topic_banner_btn_2_color,
                                  }}
                                  onClick={() => onLoginChange(true)}
                                >
                                  <span>{hubTopic.topic_banner_btn_2}</span>

                                  <span className="righ-arr">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                  </span>
                                </button>

                              ) : (

                                <a
                                  href={`/${hubTopic.topic_banner_btn_link_2}`}
                                  className="new-commom-btn hub-banner-reveal"
                                  style={{
                                    "--blur_button_color":hubTopic.topic_banner_btn_2_color,
                                    '--topic_banner_btn_2_color':hubTopic.topic_banner_btn_2_color ,
                                    '--topic_banner_btn_2_color_hover':hubTopic.topic_banner_btn_2_hover_color,
                                    '--luminus_button_color_15': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 15%, white)`,
                                    '--luminus_button_color_25': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 25%, white)`,
                                    '--luminus_button_color_38': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 38%, white)`,
                                    '--luminus_button_color_45': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 45%, white)`,
                                    '--luminus_button_color_50': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 50%, white)`,
                                    '--luminus_button_color_55': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 55%, white)`,
                                    '--luminus_button_color_70': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 70%, white)`,
                                    '--luminus_button_color_85': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 85%, white)`,
                                    '--luminus_button_color_92': `color-mix(in srgb, ${hubTopic.topic_banner_btn_2_color} 92%, white)`,
                                    '--luminus_button_color_100': hubTopic.topic_banner_btn_2_color,
                                  }}
                                >
                                  <span>{hubTopic.topic_banner_btn_2}</span>

                                  <span className="righ-arr">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                  </span>
                                </a>

                              )

                            )}

                      </div>

                      <div dangerouslySetInnerHTML={{__html:hubTopic?.topic_banner_footer}}/>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hub-section">

        <div className="container">

            <div className="row hub-pattern-card-row">

              <Breadcrumb title={hubTopic?.topic_title} hide={true} />

                <div className="quiz-topic-content" dangerouslySetInnerHTML={{__html:hubTopic?.topic_content}}/>

                <div className="hub-pattern-card-outer top-changes">

                    {hubTopic?.cards.map((card, index) => (
                        <div className="hub-pattern-cards" key={index}>
                            <div>
                            <img
                                src={`${IMG_URL}/d0/${card.hub_topic_card_image}`}
                                alt={card.hub_topic_card_image_alt}
                            />
                            </div>

                            <div className="hub-pattern-cards-content">
                            <div
                                className="hub-carrer-content"
                                dangerouslySetInnerHTML={{
                                __html: card.hub_topic_card_content,
                                }}
                            />

                            {card.hub_topic_card_button_1 && card.hub_topic_card_button_link_1 && (

                                <a href={`/${card.hub_topic_card_button_link_1}`} className="new-commom-btn hub-banner-reveal"   >
                                
                                    <span>{card.hub_topic_card_button_1}</span>

                                    <span className="righ-arr">
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                </a>
                            )}
                            </div>
                        </div>
                    ))}

                </div>

            </div>

            <div className="row hub-faq-question">

                <div className="hub-pattern-card-title faq-title-head">

                    <div dangerouslySetInnerHTML={{__html:hubTopic?.faq_content}} />

                </div>

                <div className="col-12 col-sm-12 col-md-12">

                  <div className="faq-container">

                    {faqData?.map((item, index) => (
                        <div key={index} className="faq-item" onClick={() => toggle(index)}>
                          <div className="faq-title">
                            <h3>{item.question}</h3>
                            <span className="arrow-icon">
                              <img className={openIndex === index ? "rotate1" : ""} src={arr} alt="" />
                            </span>
                          </div>
                          {openIndex === index && (
                            <div className="faq-content">
                              <p dangerouslySetInnerHTML={{ __html: item?.answer }}></p>
                            </div>
                          )}
                          <hr />
                        </div>

                    ))}
                  </div>
                </div>

            </div>

        </div>
      </div>
    </div>

      {CarrerModal && (
        <div className="newdashpop-overlay lock-dashboard carrer-banner">
          <div className="newdashpop-inner">
            <div className="newdashpop-container">
              <button
                className="newdashpop-close"
                onClick={() => {
                  setCarrerModal(false);
                  setCareerContent("");
                }}
              >
                &times;
              </button>

              <div className="conent-pop lock-dashboard-content">
                <div className="dash-loc-title">

                  <div
                    dangerouslySetInnerHTML={{ __html: careerContent }}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  );
}

export default HubTopicDetail;
